export default {
	methods: {
		updateLeaveConfirmation (changed, show, path) {
			this.$store.dispatch('setLeaveConfirmation', {
				changed: changed,
				show: show,
				path: path
			})
		}
	}
}
